import React, { useState } from 'react';
import '../styles/InquiryForm.css';

const InquiryForm = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    studentName: '',
    dateOfBirth: '',
    fatherName: '',
    motherName: '',
    emailAddress: '',
    phoneNumber: '',
    class: '',
    previousSchool: '',
    address: ''
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('/api/inquiry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) throw new Error(data.message || 'Submission failed');

      setSuccess(true);

      // 2 second baad form band karo
      setTimeout(() => {
        setSuccess(false);
        handleClose();
      }, 2000);

    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      studentName: '',
      dateOfBirth: '',
      fatherName: '',
      motherName: '',
      emailAddress: '',
      phoneNumber: '',
      class: '',
      previousSchool: '',
      address: ''
    });
    setError('');
    setSuccess(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content fade-in" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Admission Enquiry Form</h2>
          <button className="close-icon" onClick={handleClose}>×</button>
        </div>

        {/* Success Message */}
        {success && (
          <div style={{
            background: '#e8f5e9',
            color: '#2e7d32',
            padding: '14px 20px',
            margin: '0 20px 16px',
            borderRadius: '8px',
            fontWeight: '600',
            textAlign: 'center',
            border: '1px solid #a5d6a7'
          }}>
            ✅ Inquiry submitted successfully!
          </div>
        )}

        {/* Error Message */}
        {error && (
          <div style={{
            background: '#ffebee',
            color: '#c62828',
            padding: '14px 20px',
            margin: '0 20px 16px',
            borderRadius: '8px',
            fontWeight: '600',
            textAlign: 'center',
            border: '1px solid #ef9a9a'
          }}>
            ❌ {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="studentName">Student Name <span style={{color: '#d32f2f'}}>*</span></label>
              <input
                type="text"
                id="studentName"
                name="studentName"
                placeholder="Enter student name"
                value={formData.studentName}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="dateOfBirth">Date of Birth <span style={{color: '#d32f2f'}}>*</span></label>
              <input
                type="date"
                id="dateOfBirth"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="fatherName">Father's Name <span style={{color: '#d32f2f'}}>*</span></label>
              <input
                type="text"
                id="fatherName"
                name="fatherName"
                placeholder="Enter father's name"
                value={formData.fatherName}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="motherName">Mother's Name <span style={{color: '#d32f2f'}}>*</span></label>
              <input
                type="text"
                id="motherName"
                name="motherName"
                placeholder="Enter mother's name"
                value={formData.motherName}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="emailAddress">Email <span style={{color: '#d32f2f'}}>*</span></label>
              <input
                type="email"
                id="emailAddress"
                name="emailAddress"
                placeholder="Enter email address"
                value={formData.emailAddress}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="phoneNumber">Phone Number <span style={{color: '#d32f2f'}}>*</span></label>
              <input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                placeholder="Enter phone number"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-group full-width">
            <label htmlFor="class">Apply for Class <span style={{color: '#d32f2f'}}>*</span></label>
            <select
              id="class"
              name="class"
              value={formData.class}
              onChange={handleChange}
              required
              disabled={loading}
            >
              <option value="">Select Class</option>
              <option value="Nursery">Nursery (Kindergarten)</option>
              <option value="LKG">LKG</option>
              <option value="UKG">UKG</option>
              <option value="Class 1">Class 1</option>
              <option value="Class 2">Class 2</option>
              <option value="Class 3">Class 3</option>
              <option value="Class 4">Class 4</option>
              <option value="Class 5">Class 5</option>
              <option value="Class 6">Class 6</option>
              <option value="Class 7">Class 7</option>
              <option value="Class 8">Class 8</option>
              <option value="Class 9">Class 9</option>
              <option value="Class 10">Class 10</option>
              <option value="Class 11">Class 11</option>
              <option value="Class 12">Class 12</option>
            </select>
          </div>

          <div className="form-group full-width">
            <label htmlFor="previousSchool">Previous School</label>
            <input
              type="text"
              id="previousSchool"
              name="previousSchool"
              placeholder="Enter previous school name (Optional)"
              value={formData.previousSchool}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="form-group full-width">
            <label htmlFor="address">Address</label>
            <textarea
              id="address"
              name="address"
              placeholder="Enter your address"
              value={formData.address}
              onChange={handleChange}
              rows="4"
              disabled={loading}
              style={{
                padding: '12px 15px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '15px',
                fontFamily: 'inherit',
                resize: 'vertical',
                transition: 'all 0.3s ease'
              }}
            />
          </div>

          <div className="form-actions">
            <button
              type="submit"
              className="btn-submit"
              disabled={loading}
              style={{ opacity: loading ? 0.7 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
            >
              {loading ? 'Submitting...' : 'Submit Enquiry'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InquiryForm;